"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t={haLoginButton:"health-assistant-login-button",desktopNavigation:"desktop-navigation",languageDropdown:"language-dropdown"};exports.dataTestIds=t;
